// Profile4System.js

import {
    axios,
    useImperativeHandle, forwardRef, useRef, useContext, useState, useEffect,
    useSelector, useDispatch,
    useLocation, useNavigate, Link,
    AppTheme,
    mui, reducer, component, useShared,  
    replaceTabVerseListNewItem, setRead, getYearOfBirthList, localizedDateTime, verseRangeChineseName, sortResultList, canPushNewEntry, Highlight, resetSelectedAll, getBookChapterVerseChineseName, getChapterChineseName, getBookChapterChineseName, getTabLabel,
    VERSION, COUNTRY_LIST, MAX_LENGTH_SEARCH_STRING, MAX_LENGTH_NOTE_CONTENT, MAX_LENGTH_NOTE_TITLE, SPACE, API_BASE_URL, MAX_LENGTH_NON_SEARCH_STRING1, MAX_LENGTH_NON_SEARCH_STRING2,
    homeContext, searchContext, noteContext,
} from '../Utilities/sharedHeader';

const Profile4System = forwardRef((props, ref) => {

    useImperativeHandle(ref, () => ({
        validateInputs,
    }));
    
    const { mode, userListItem } = props;

    const { Slider, Snackbar, styled, grey, Grid, Chip, Divider, Tab, Tabs, Box, Accordion, AccordionSummary, AccordionDetails, ListItemIcon, List, ListItem, ListItemText, TextField, IconButton, InputBase, Paper, Alert, Select, FormControl, FormControlLabel, FormLabel, FormGroup, MenuItem, Container, Typography, ButtonGroup, Button, Stack, Fab, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Radio, RadioGroup, AppBar, Toolbar, Table, TableContainer, TableBody, TableRow, TableCell, CardMedia, CardContent, CssBaseline, FormHelperText, Switch, Card, CheckIcon, ClearIcon, DeleteIcon, CloseIcon, ExpandMoreIcon, VisibilityOutlinedIcon, KeyboardArrowUpIcon, KeyboardDoubleArrowUpIcon, HistoryIcon, StickyNote2Icon, NoteAddIcon, SearchIcon, DescriptionIcon, EditDocumentIcon, ImportContactsIcon, WestIcon, EastIcon, HomeIcon, PersonIcon, LogoutIcon, PlagiarismIcon, DeviceThermostatIcon, FileCopyIcon, LocalOfferIcon, InfoIcon } = mui;
    const { setButtonTextDialog4, setButtonText, setDialogTitle, setBookReadLogToBeCleared, setCallerConfirmationDialog, setCaller4NoteBookmarkList, setNoteSearchString, setConfirmedNoteSearchString, setNoteSearchStringClearButton, setShowRemainingNoteSearch, setSearchCriteriaListItem2, setSearchResultVerseList2, setPageNumberNoteSearch, setVerseListItem2, setNoteSearchStringPlaceHolder, reset4NoteSearch, setTabVerseListNew, reset4SignIn, setTitleToBeDeleted, reset4ConfirmationDialog, reset4GoToTopButtonVisible, reset4NoteBookmarkList, reset4Dialog4, reset4NoteBookmarkVerseList, reset4ChipArray, reset4verseLabelArrows4Result, reset4Switch1, reset4Dialog2, reset4Search, reset4Verse, reset4Chapter, reset4Book, reset4Home, setGoToTopButtonVisible, setVerseListItem, setNonSearchString1PlaceHolder, setNonSearchString2PlaceHolder, setSearchStringPlaceHolder, setSearchString, setShowLeftArrowVerseSearch, setShowRightArrowVerseSearch, setShowfabContentVerseSearch, setShowLeftArrowNote, setShowRightArrowNote, setShowfabContentNote, setShowLeftArrowNoteSearch, setShowRightArrowNoteSearch, setShowfabContentNoteSearch, setSearchCriteriaListItem, setPageNumberVerseSearch, setOpenConfirmationDialog, setOpen3, setConfirmedTabNumber, setOpen2, setPageNumberNote, setDetails, setLengthIndicator4Details, setLengthIndicator4Title, setLoading, setHistoryList, setHistoryListItemSelected, setHistoryBookChapter, setNoteBookmarkList, setNoteBookmarkListBookChapterVerse, setConfirmedSearchString, setNonSearchString1, setNonSearchString2, setSearchStringClearButton, setNonSearchStringClearButton, setSearchScopeList, setSearchScopeListItemSelected, setChipData, setShowRemaining, setSearchResultVerseList, setSearchHttpPostData, setBookChapterList, setBookChapterListItemSelected, setOpen1, setBookListItemSelected, setSearchCriteria, setLoading4Home, setUserListItem, setVerseReadLogList4Book, setSearchTabNumber, setBookChapter, setBookList, setTitle, setTitleClearButton, setBook4Accordion1, setChapter4Accordion1, setVerse4Accordion1, setBookChapter2, setBookChapterList2, setVerseList4Accordion1, setNoteBookmarkVerseList, setNoteBookmarkListItemToBeDeleted, setNoteBookmarkListItemToBeChanged, setTab4AddChange, setViewArea, setCredential, setCircularProgressText, setEmailExisted, setUsernameExisted, setLastNameOverMaxLength, setFirstNameOverMaxLength, reset4Profile } = reducer;
    const { SignUpEmailSent, Profile4System, Profile4Personal, History, AddChangeNote, FullFormatVerse, Book, Stack1, NoteVerseList, Chapter, Dialog1, Dialog2, Dialog3, Dialog4, Tab1, Navbar, VerseSearch, Verse, NoteBookmarkList, NoteBookmarkListItem, VerseLabelArrows4Result, ConfirmationDialog, Accordion1, ChipArray, SearchResult, ForgotPassword, ClipLoader1, VerseLabelArrows, Switch1, Selection, Profile, UserListItem } = component;  
    const { postUserListItem, bookRead, deleteVerseReadLogList, getNoteBookmarkList3, deleteLogListItem, getToken, postLogListItem, postPutSearchCriteriaListItem, deleteVerseReadLogListItem, postPutVerseReadLogListItem, postHistoryListItem, getHasNoteVersesAll, getSearchResultVerseList, getSearchCriteriaListItem, postNoteBookmarkListItem, putNoteBookmarkListItem2, putNoteBookmarkListItem1, getNoteBookmarkList, getVerseReadLogList4Book, getSearchScopeList, getVerseList4Accordion1, getUserListItem, getVerseList, getBookList, getHistoryList, putUserListItem } = useShared();

    const dispatch = useDispatch(); // dispatch(
    //const userListItemToBeChanged = useSelector((state) => state.profile.userListItemToBeChanged);
    const bookList = useSelector((state) => state.home.bookList);

    const [verseSearchResultPerPage, setVerseSearchResultPerPage] = useState(userListItem.VerseSearchResultPerPage);
    const [notePerPage, setNotePerPage] = useState(userListItem.NotePerPage);
    const [historyListItemTotal, setHistoryListItemTotal] = useState(userListItem.HistoryListItemTotal);    
    const [verseFontSize, setVerseFontSize] = useState(userListItem.VerseFontSize);
    const [book4Clear, setBook4Clear] = useState(0);

    const marks4VerseSearchResultPerPage = [
        { value: 5, label: '5' },
        { value: 10, label: '10' },
        { value: 15, label: '15' },
        { value: 20, label: '20' },
        { value: 25, label: '25' },
    ];

    const marks4NotePerPage = [
        { value: 2, label: '2' },
        { value: 4, label: '4' },
        { value: 6, label: '6' },
        { value: 8, label: '8' },
        { value: 10, label: '10' },
        { value: 12, label: '12' },
    ];

    const marks4HistoryListItemTotal = [
        { value: 5, label: '5' },
        { value: 6, label: '6' },
        { value: 7, label: '7' },
        { value: 8, label: '8' },
        { value: 9, label: '9' },
        { value: 10, label: '10' },
    ];

    const marks4VerseFontSize = [
        { value: 12, label: '12' },
        { value: 14, label: '14' },
        { value: 16, label: '16' },
        { value: 18, label: '18' },
        { value: 20, label: '20' },
        { value: 22, label: '22' },
        { value: 24, label: '24' },
        { value: 26, label: '26' },
        { value: 28, label: '28' },
        { value: 30, label: '30' },
        { value: 32, label: '32' },
    ];

    // const setValue = (e) => {
    //     let name = e.target.name;
    //     let value = e.target.value;
    //     const item = {...userListItemToBeChanged, [name]: value}
    //     //dispatch(setUserListItemToBeChanged(item));
    // }

    const validateInputs = async () => {
        const item = {
            VerseSearchResultPerPage: verseSearchResultPerPage,
            NotePerPage: notePerPage,
            HistoryListItemTotal: historyListItemTotal,
            VerseFontSize: verseFontSize
        }
        //profile4SystemAddedChanged(item);    
        return item;
    }

    const handleChangeVerseSearchResultPerPage = async (value) => {
        setVerseSearchResultPerPage(value);
    }

    const handleChangeNotePerPage = async (value) => {
        setNotePerPage(value);
    }

    const handleChangeHistoryListItemTotal = async (value) => {
        setHistoryListItemTotal(value);
    }    

    const handleChangeVerseFontSize = async (value) => {
        setVerseFontSize(value);
    }    

    const handleOnChangeClear = (e) => {
        let book = e.target.value;
        setBook4Clear(book);
    };

    const handleOnClickClearAll = (e) => {
        dispatch(setCallerConfirmationDialog('Profile'));
        dispatch(setButtonText('刪除'));
        dispatch(setTitleToBeDeleted('刪除所有書卷「已讀」記錄？'));
        dispatch(setBookReadLogToBeCleared(0));
        dispatch(setOpenConfirmationDialog(true));
    };

    const handleOnClickClearOne = (e) => {
        if (book4Clear > 0) {
            const chineseName = bookList[book4Clear-1].Chinese_Name;
            dispatch(setCallerConfirmationDialog('Profile'));
            dispatch(setButtonText('刪除'));
            dispatch(setTitleToBeDeleted(`刪除${chineseName}「已讀」記錄？`));
            dispatch(setBookReadLogToBeCleared(book4Clear));
            dispatch(setOpenConfirmationDialog(true));
        }
    };

    return (

        <div>        

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>

                <Divider>系統設定</Divider>

                <Grid container spacing={2} sx={{ paddingTop: '20px', paddingLeft: '50px', paddingRight: '50px', alignItems: 'center' }}>

                    <Grid container spacing={0} size={12}>

                        <Grid size={12}>
                            搜尋結果每頁顯示數目：{verseSearchResultPerPage}
                        </Grid>

                        <Grid size={12}>
                            <Slider
                                name='VerseSearchResultPerPage'
                                value={verseSearchResultPerPage || 0}
                                step={5}
                                min={5}
                                max={25}
                                marks={marks4VerseSearchResultPerPage}
                                onChange={(event, value) => handleChangeVerseSearchResultPerPage(value)}
                            />
                        </Grid>   

                    </Grid>

                    <Grid container spacing={0} size={12}>

                        <Grid size={12}>
                            筆記每頁顯示數目：{notePerPage}
                        </Grid>

                        <Grid size={12}>
                            <Slider
                                name='NotePerPage'
                                value={notePerPage || 0}
                                step={2}
                                min={2}
                                max={12}
                                marks={marks4NotePerPage}
                                onChange={(event, value) => handleChangeNotePerPage(value)}
                            />
                        </Grid>   

                    </Grid>  

                    <Grid container spacing={0} size={12}>

                        <Grid size={12}>
                            讀經歷史顯示數目：{historyListItemTotal}
                        </Grid>

                        <Grid size={12}>
                            <Slider
                                name='HistoryListItemTotal'
                                value={historyListItemTotal || 0}
                                step={1}
                                min={5}
                                max={10}
                                marks={marks4HistoryListItemTotal}
                                onChange={(event, value) => handleChangeHistoryListItemTotal(value)}
                            />
                        </Grid> 

                    </Grid>  

                    <Grid container spacing={0} size={12}>

                        <Grid size={12}>
                            經文、筆記內容字體大小：{verseFontSize}
                        </Grid>

                        <Grid size={12}>
                            <Slider
                                name='VerseFontSize'
                                value={verseFontSize || 0}
                                step={2}
                                min={12}
                                max={32}
                                marks={marks4VerseFontSize}
                                onChange={(event, value) => handleChangeVerseFontSize(value)}
                            />
                        </Grid> 

                    </Grid>                     

                    <Grid container spacing={0} size={12} sx={{ paddingTop: '30px'}}>

                        <Grid size={10}>
                            刪除所有書卷「已讀」記錄：
                        </Grid>

                        <Grid size={2}>
                            <IconButton
                                sx={{
                                    borderRadius: 1,
                                    bgcolor: 'warning.main',
                                    '&:hover': { bgcolor: 'warning.main' },
                                    width: '100%',
                                }}
                                onClick={handleOnClickClearAll}
                            >
                                <DeleteIcon sx={{ color: 'white' }} />
                            </IconButton> 
                        </Grid> 

                    </Grid>

                    <Grid container spacing={0} size={12}>

                        <Grid size={12}>
                            刪除個別書卷「已讀」記錄：
                        </Grid>

                        <Grid size={12}>

                            <Box
                                sx={{
                                borderRadius: '4px', // typical MUI chip border radius
                                border: '1px solid',
                                borderColor: 'warning.main',
                                display: 'flex',
                                height: 19, // typical chip height
                                padding: 1,
                                }}
                            >

                                <Select
                                value={book4Clear}
                                onChange={handleOnChangeClear}
                                input={<InputBase />}
                                fullWidth
                                >

                                    <MenuItem key={0} value={0}>請選擇聖經卷</MenuItem>
                                    {bookList.map(bookListItem => (
                                    <MenuItem key={ bookListItem.Number } value={ bookListItem.Number }>
                                        { bookListItem.Chinese_Name }【{ bookListItem.Chinese_Code }】{bookListItem.Read && '(已讀)'}
                                    </MenuItem>
                                    ))}

                                </Select>   

                                <IconButton
                                sx={{
                                    borderRadius: 0,
                                    bgcolor: 'warning.main',
                                    '&:hover': { bgcolor: 'warning.main' },
                                    margin: -1
                                }}
                                onClick={handleOnClickClearOne}
                                >
                                <DeleteIcon sx={{ color: 'white' }} />
                                </IconButton>        

                            </Box>

                        </Grid>                        

                    </Grid>

                </Grid>

            </Box>

            <ConfirmationDialog />
            
        </div>

    )

});

export default Profile4System;